define ['./forms.scss'], () ->
  ($scope, $state, $rootScope) ->
    if $rootScope.stored_form_data
      $scope.data = angular.copy($rootScope.stored_form_data)
      $rootScope.stored_form_data = null
    else
      $scope.data = {}

    $scope.steps_mapping = [
      'root.forms.select_reports',
      'root.forms.create_name'
    ]

    $scope.display_subnav = true

    $scope.$watch(() ->
      $state.$current.name
    , (newVal, oldVal) ->
      $scope.current_state = $state.$current.name

      if $scope.current_state.indexOf('quick_form') >= 0
        $scope.display_subnav = false
    )



// WEBPACK FOOTER //
// ./components/forms/forms.coffee